import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  {axiosClientSignIn} from '../axios/api.js'

// ✅ Fetch tickets (filter by userId and type)
export const fetchTickets = createAsyncThunk(
  "tickets/fetchTickets",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { userId, filterType, status, priority ,departmentId} = params;
      console.log(params)
      const queryParams = new URLSearchParams();
       
      if (userId) queryParams.append('userId', userId);
      if (filterType) queryParams.append('filterType', filterType);
      if (status) queryParams.append('status', status);
      if (priority) queryParams.append('priority', priority);
      if(departmentId)  queryParams.append('departmentId', departmentId);
      
      const res = await axiosClientSignIn.get(`/help/tickets?${queryParams.toString()}`);
        console.log("Response Data:", res.data);
console.log("Type of Data:", typeof res.data);
console.log("Is Array?", Array.isArray(res.data));
      return res.data;
    } catch (err) {
      console.log(err)
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch tickets created by me
export const fetchMyCreatedTickets = createAsyncThunk(
  "tickets/fetchMyCreatedTickets",
  async (params = {}, { rejectWithValue }) => {
    console.log(params)
    try {
     const { userId, filterType, status, priority ,departmentId} = params;
           const queryParams = new URLSearchParams();
       
      if (userId) queryParams.append('userId', userId);
      if (filterType) queryParams.append('filterType', filterType);
      if (status) queryParams.append('status', status);
      if (priority) queryParams.append('priority', priority);
      if(departmentId)  queryParams.append('departmentId', departmentId);
      const res = await axiosClientSignIn.get(`/help/tickets/created-by-me?${queryParams.toString()}`);
  console.log("Response Data:", res.data);
console.log("Type of Data:", typeof res.data);
console.log("Is Array?", Array.isArray(res.data));
      return res.data;
    } catch (err) {
      console.log(err)
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch tickets assigned to me
export const fetchMyAssignedTickets = createAsyncThunk(
  "tickets/fetchMyAssignedTickets",
  async (params = {}, { rejectWithValue }) => {
          const queryParams = new URLSearchParams();
        const { userId, filterType, status, priority ,departmentId} = params;
      if (userId) queryParams.append('userId', userId);
      if (filterType) queryParams.append('filterType', filterType);
      if (status) queryParams.append('status', status);
      if (priority) queryParams.append('priority', priority);
      if(departmentId)  queryParams.append('departmentId', departmentId);
    console.log('tickets/fetchMyAssignedTickets')
    try {
      const res = await axiosClientSignIn.get(`/help/tickets/assigned-to-me?${queryParams.toString()}`);
        console.log("Response Data:", res.data);
console.log("Type of Data:", typeof res.data);
console.log("Is Array?", Array.isArray(res.data));
      console.log(res.data)
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch open tickets
export const fetchOpenTickets = createAsyncThunk(
  "tickets/fetchOpenTickets",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { departmentId } = params;
      const queryParams = new URLSearchParams();
      if (departmentId) queryParams.append('departmentId', departmentId);
      
      const res = await axiosClientSignIn.get(`/help/tickets/open?${queryParams.toString()}`);
      console.log("Open Tickets Response:", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch resolved tickets
export const fetchResolvedTickets = createAsyncThunk(
  "tickets/fetchResolvedTickets",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { departmentId } = params;
      const queryParams = new URLSearchParams();
      if (departmentId) queryParams.append('departmentId', departmentId);
      
      const res = await axiosClientSignIn.get(`/help/tickets/resolved?${queryParams.toString()}`);
      console.log("Resolved Tickets Response:", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch closed tickets
export const fetchClosedTickets = createAsyncThunk(
  "tickets/fetchClosedTickets",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { departmentId } = params;
      const queryParams = new URLSearchParams();
      if (departmentId) queryParams.append('departmentId', departmentId);
      
      const res = await axiosClientSignIn.get(`/help/tickets/closed?${queryParams.toString()}`);
      console.log("Closed Tickets Response:", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch all user related tickets
export const fetchAllUserTickets = createAsyncThunk(
  "tickets/fetchAllUserTickets",
  async (params = {}, { rejectWithValue }) => {
    try {
      const { departmentId } = params;
      const queryParams = new URLSearchParams();
      if (departmentId) queryParams.append('departmentId', departmentId);
      
      const res = await axiosClientSignIn.get(`/help/tickets/all-user?${queryParams.toString()}`);
      console.log("All User Tickets Response:", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Get specific ticket by ID
export const fetchTicketById = createAsyncThunk(
  "tickets/fetchTicketById",
  async (ticketId, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.get(`/help/tickets/${ticketId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Create ticket with FormData support
export const createTicket = createAsyncThunk(
  "tickets/createTicket",
  async (ticketData, { rejectWithValue }) => {
    // console.log("helpticketehelptciket")
  
    try {
      // Check if ticketData is FormData
      const config = ticketData instanceof FormData 
        ? { headers: { 'Content-Type': 'multipart/form-data' } }
        : { headers: { 'Content-Type': 'application/json' } };
      // console.log(ticketData)
      const res = await axiosClientSignIn.post('/help/tickets', ticketData, config);
      return res.data.ticket; // Return the ticket from response
    } catch (err) {
      console.log(err)
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Update ticket (status / reply / assignment)
export const updateTicket = createAsyncThunk(
  "tickets/updateTicket",
  async ({ ticketId, updates }, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.put(`/help/tickets/${ticketId}`, updates);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Delete ticket
export const deleteTicket = createAsyncThunk(
  "tickets/deleteTicket",
  async (ticketId, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/help/tickets/${ticketId}`);
      return ticketId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch departments
export const fetchDepartments = createAsyncThunk(
  "tickets/fetchDepartments",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.get('/department/get/department');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch users by department
export const fetchUsersByDepartment = createAsyncThunk(
  "tickets/fetchUsersByDepartment",
  async (departmentId, { rejectWithValue }) => {
    console.log(departmentId,"deparmentbyid")
    try {
      
      const res = await axiosClientSignIn.get(`/userlist/${departmentId}/users`);
      console.log(res.data)
      return res.data;
    } catch (err) {
      console.log(err)
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ✅ Fetch open tickets count for current user
export const fetchOpenTicketsCount = createAsyncThunk(
  "tickets/fetchOpenTicketsCount",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.get('/help/tickets/open-count');
      console.log('📊 Open tickets count response:', res.data);
      return res.data; // Return full response object
    } catch (err) {
      console.error('❌ Error fetching open tickets count:', err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const ticketSlice = createSlice({
  name: "tickets",
  initialState: {
    tickets: [],
    selectedTicket: null,
    selectedDepartment: null,
    departments: [],
    departmentUsers: [],
    openTicketsCount: 0,
    createdTicketsCount: 0,
    assignedTicketsCount: 0,
    countLoading: false,
    loading: false,
    departmentsLoading: false,
    usersLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setSelectedTicket: (state, action) => {
      state.selectedTicket = action.payload;
    },
    setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },
    incrementOpenTicketsCount: (state) => {
      state.openTicketsCount += 1;
    },
    decrementOpenTicketsCount: (state) => {
      state.openTicketsCount = Math.max(0, state.openTicketsCount - 1);
    },
    setOpenTicketsCount: (state, action) => {
      state.openTicketsCount = action.payload;
    },
    setCreatedTicketsCount: (state, action) => {
      state.createdTicketsCount = action.payload;
    },
    setAssignedTicketsCount: (state, action) => {
      state.assignedTicketsCount = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch all tickets
      .addCase(fetchTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch my created tickets
      .addCase(fetchMyCreatedTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyCreatedTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchMyCreatedTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch my assigned tickets
      .addCase(fetchMyAssignedTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMyAssignedTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchMyAssignedTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch ticket by ID
      .addCase(fetchTicketById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTicketById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTicket = action.payload;
      })
      .addCase(fetchTicketById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create ticket
      .addCase(createTicket.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTicket.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets.push(action.payload);
      })
      .addCase(createTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update ticket
      .addCase(updateTicket.fulfilled, (state, action) => {
        const idx = state.tickets.findIndex(t => t._id === action.payload._id);
        if (idx !== -1) {
          state.tickets[idx] = action.payload;
        }
        if (state.selectedTicket?._id === action.payload._id) {
          state.selectedTicket = action.payload;
        }
      })

      // Delete ticket
      .addCase(deleteTicket.fulfilled, (state, action) => {
        state.tickets = state.tickets.filter(t => t._id !== action.payload);
        if (state.selectedTicket?._id === action.payload) {
          state.selectedTicket = null;
        }
      })

      // Fetch departments
      .addCase(fetchDepartments.pending, (state) => {
        state.departmentsLoading = true;
      })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.departmentsLoading = false;
        state.departments = action.payload;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.departmentsLoading = false;
        state.error = action.payload;
      })

      // Fetch users by department
      .addCase(fetchUsersByDepartment.pending, (state) => {
        state.usersLoading = true;
      })
      .addCase(fetchUsersByDepartment.fulfilled, (state, action) => {
        state.usersLoading = false;
        console.log("fetchUsersByDepartment")
        console.log( action.payload)
        state.departmentUsers = action.payload.users;
      })
      .addCase(fetchUsersByDepartment.rejected, (state, action) => {
        state.usersLoading = false;
        state.error = action.payload;
      })

      // Fetch open tickets
      .addCase(fetchOpenTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpenTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchOpenTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch resolved tickets
      .addCase(fetchResolvedTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResolvedTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchResolvedTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch closed tickets
      .addCase(fetchClosedTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClosedTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchClosedTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch all user tickets
      .addCase(fetchAllUserTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUserTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload;
      })
      .addCase(fetchAllUserTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch open tickets count
      .addCase(fetchOpenTicketsCount.pending, (state) => {
        state.countLoading = true;
      })
      .addCase(fetchOpenTicketsCount.fulfilled, (state, action) => {
        state.countLoading = false;
        state.openTicketsCount = action.payload.count || 0;
        state.createdTicketsCount = action.payload.createdCount || 0;
        state.assignedTicketsCount = action.payload.assignedCount || 0;
      })
      .addCase(fetchOpenTicketsCount.rejected, (state, action) => {
        state.countLoading = false;
        state.error = action.payload;
      });
  },
});

export const { 
  clearError, 
  setSelectedTicket, 
  setSelectedDepartment, 
  incrementOpenTicketsCount, 
  decrementOpenTicketsCount, 
  setOpenTicketsCount,
  setCreatedTicketsCount,
  setAssignedTicketsCount
} = ticketSlice.actions;
export default ticketSlice.reducer;
